export const GET_STREETS = '/get_street';
export const GET_SINGLE_STREET = '/get_single_street';
export const UPDATE_STREET = '/update_street';
export const CREATE_STREET = '/create_street';
export const REMOVE_STREET = '/remove_street';
export const GET_LOCATION_LIST = 'street/get_location_list';

export const FORM_DATA = {
  name: '',
  code: '',
  rptax_location_id: '',
};